import styled, { keyframes, css } from "styled-components";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";

const slideInFromLeft = keyframes`
    0% {
        opacity: 0;
        transform: translateX(-5px);
    }
    100% {
        opacity: 1;
        transform: translateX(0);
    }
`;

const textShimmer = keyframes`
    from {
        background-position: 100% center;
    }
    to {
        background-position: 0% center;
    }
`;

const groupIndicatorWidth = "3px";

export const Container = styled.div<{
    gutterPresent?: boolean;
    menuItemsCalloutPresent?: boolean;
    background?: string;
    isIrctcCartSession?: boolean;
}>(({ gutterPresent, menuItemsCalloutPresent, theme, background, isIrctcCartSession }) => ({
    display: "flex",
    padding: `${theme.spacing.small} ${theme.spacing.medium} ${theme.spacing.empty}`,

    "&:last-child": {
        padding: `${theme.spacing.small} ${theme.spacing.medium} ${isIrctcCartSession ? theme.spacing.medium : theme.spacing.xSmall}`,
    },

    "&:first-child": {
        paddingTop: `${theme.spacing.medium}`,

        ...(menuItemsCalloutPresent && {
            paddingTop: `${theme.spacing.xxSmall}`,

            ...(gutterPresent && {
                paddingTop: `${theme.spacing.medium}`,
            }),
        }),
    },

    ...(gutterPresent && {
        padding: `${theme.spacing.small} ${theme.spacing.medium}`,
        background: background || "transparent",
        borderRadius: `${theme.spacing.medium} ${theme.spacing.medium} ${theme.spacing.empty} ${theme.spacing.empty}`,
    }),
}));

export const IconContainer = styled.div(({ theme }) => ({
    marginRight: theme.spacing.xxSmall,
    position: "relative",
    alignSelf: "center",
}));

export const LottieContainer = styled.div(({ theme }) => ({
    width: theme.spacing.medium,
    height: theme.spacing.large,
    marginRight: `calc(${theme.spacing.xxxSmall} / -2)`,
    alignSelf: "center",
}));

export const ContainerItems = styled.div({
    width: `calc(100% - ${groupIndicatorWidth} - 16px)`,
    flex: 1,
});

export const ContainerItemsList = styled.div(({ theme }) => ({
    marginTop: theme.spacing.empty,
    marginBottom: theme.spacing.xxSmall,
}));

export const ItemListHeader = styled.div<{ isAnimation?: boolean; backgroundColor?: string; hasLottie?: boolean }>`
    padding-bottom: ${({ theme }) => theme.spacing.xxSmall};
    display: flex;
    ${({ isAnimation, backgroundColor, hasLottie, theme }) =>
        isAnimation &&
        hasLottie &&
        css`
            background: ${backgroundColor};
            padding: ${theme.spacing.small} ${theme.spacing.empty} ${theme.spacing.xSmall}
                calc(${theme.spacing.xSmall} + ${theme.spacing.xxxSmall});
            margin-left: calc(-1 * (${theme.spacing.xSmall} + ${theme.spacing.xxxSmall}));
            margin-top: calc(-1 * (${theme.spacing.xSmall} + ${theme.spacing.xxxSmall}));
            border-radius: ${theme.spacing.medium} ${theme.spacing.medium} ${theme.spacing.empty} ${theme.spacing.empty};
            margin-bottom: ${theme.spacing.medium};
        `}
`;

export const ItemListHeaderTitle = styled(Text)<{
    isAnimation?: boolean;
    startAnimation?: boolean;
    hasLottie?: boolean;
}>`
    padding-bottom: ${({ theme }) => theme.spacing.xxSmall};
    ${({ isAnimation, startAnimation = true, hasLottie }) =>
        isAnimation &&
        hasLottie &&
        css`
            background: linear-gradient(90deg, currentColor 40%, #fff 50%, currentColor 60%);
            background-size: 300% 100%;
            background-position: 100% center;
            -webkit-background-clip: text;
            background-clip: text;
            -webkit-text-fill-color: transparent;
            ${startAnimation &&
            css`
                animation:
                    ${slideInFromLeft} 0.4s ease-out forwards,
                    ${textShimmer} 1.5s linear 0.4s 3;
            `}
        `}
`;
